import i18n from "i18n";
import watchlistFields from "security-content/mappings/watchlistFields";
const fieldIsOnWatchlist = (watchlistStatus, wlFieldType, field) => {
  var _a;
  return !!((_a = watchlistStatus == null ? void 0 : watchlistStatus[wlFieldType]) == null ? void 0 : _a.some((match) => match.fieldName === field));
};
const findWatchlistMatch = (watchlistStatus, wlFieldType, field) => {
  var _a;
  return (_a = watchlistStatus == null ? void 0 : watchlistStatus[wlFieldType]) == null ? void 0 : _a.find((match) => match.fieldName === field);
};
const WatchlistAddition = {
  handler: (lookupTableKey, addToWatchlist) => ({ value }) => addToWatchlist({ watchlistFieldType: lookupTableKey, value }),
  isHidden: (watchlistFieldType, field, isPermitted, watchlistStatus) => !isPermitted("watchlist:edit") || !watchlistFields[watchlistFieldType].includes(field) || fieldIsOnWatchlist(watchlistStatus, watchlistFieldType, field)
};
const WatchlistRemoval = {
  handler: (lookupTableKey, removeFromWatchlist, watchlistTitle) => ({ value, field, contexts }) => {
    var _a;
    const match = findWatchlistMatch((_a = contexts == null ? void 0 : contexts.watchlistStatus) == null ? void 0 : _a.status, lookupTableKey, field);
    if (match == null ? void 0 : match.matchedViaRange) {
      const confirmMessage = i18n.t("watchlist_removal.confirm_range", {
        ns: "enterprise_security_app",
        range: match.matchedEntry,
        title: watchlistTitle
      });
      if (!window.confirm(confirmMessage)) {
        return Promise.resolve();
      }
      return removeFromWatchlist({ watchlistFieldType: lookupTableKey, value: match.matchedEntry });
    }
    return removeFromWatchlist({ watchlistFieldType: lookupTableKey, value });
  },
  isHidden: (watchlistFieldType, field, isPermitted, watchlistStatus) => !isPermitted("watchlist:delete") || !watchlistFields[watchlistFieldType].includes(field) || !fieldIsOnWatchlist(watchlistStatus, watchlistFieldType, field)
};
const WatchlistActionHelp = (isEnabled) => {
  if (!isEnabled) {
    return {
      title: i18n.t("watchlist_action_help.title", { ns: "enterprise_security_app" }),
      description: i18n.t("watchlist_action_help.description", { ns: "enterprise_security_app" })
    };
  }
  return void 0;
};
export { WatchlistAddition, WatchlistRemoval, WatchlistActionHelp };
